import { render, staticRenderFns } from "./SkillPhaseModal.vue?vue&type=template&id=345ab81e&scoped=true"
import script from "./SkillPhaseModal.vue?vue&type=script&lang=js"
export * from "./SkillPhaseModal.vue?vue&type=script&lang=js"
import style0 from "./SkillPhaseModal.vue?vue&type=style&index=0&id=345ab81e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345ab81e",
  null
  
)

export default component.exports